export const IS_USERCOM_ACTIVE = false;
export const USERCOM_CART_SEGMENT_ID = Number(
  process.env.VSF_USERCOM_CART_SEGMENT_ID,
);
export const USERCOM_PRODUCT_SEGMENT_ID = Number(
  process.env.VSF_USERCOM_PRODUCT_SEGMENT_ID,
);
